import { SavedFilters, FilterKeys, Filters, SelectedFilters, PageType } from '@utils/pageConfig/Types';
import { isEmpty, isEqual } from 'lodash';
import { formatPriceBandAsPerExchangeRate } from '@utils/Formatters';
export function getCountryOptionValue(option: any, countryList: any[]): any {
    const found = countryList.find((filterOption: any) => isEqual(filterOption.name, option.label));
    return found ? found.id : option.value;
  }
 export function processCountryFilterOptions(card: SavedFilters, countryList: any[]): string[] {
   const countryFilters = card.filters.filter((filter) => filter.filterKey === FilterKeys.COUNTRY);
   let result: string[] = [];
   countryFilters.forEach((countryFilter) => {
     countryFilter.options.forEach((option) => {
       option.value = getCountryOptionValue(option, countryList);
       result.push(option.value);
     });
   });
   return result;
 }
export function processPricebandFilterOptions(
  card: SavedFilters,
  featureListAvailable: any,
  featureListAvailableWeekly: any,
  currencyExchangeRate: number,
) {
  const pricebandFilters = card.filters.filter((filter) => filter.filterKey === FilterKeys.PRICEBAND);

  pricebandFilters.forEach((filter) => {
    filter.options = filter.options.map((option) => {
      let newValue = option.value;
      let newLabel = option.label;

      if (String(option?.value).length < 2) {
        const pricebandIndex = parseInt(String(option.value), 10);
        const pricebandValue = isEmpty(featureListAvailable?.options[pricebandIndex]?.value)
          ? featureListAvailableWeekly?.options[pricebandIndex]?.value!
          : featureListAvailable?.options[pricebandIndex]?.value!;
        newValue = pricebandValue;
        newLabel = pricebandValue;
      }
      if (currencyExchangeRate > 1 && newValue) {
        newLabel = formatPriceBandAsPerExchangeRate(newValue, currencyExchangeRate);
      }
      return { ...option, value: newValue, label: newLabel };
    });
  });
}

 export function getAdjustedFilterOptions(
    filterOption: Filters,
    filter: SelectedFilters,
    currentPageFilters: Filters[] | undefined,
    pageWithPG: PageType[],
  ) {
    const matchingFilter = currentPageFilters?.find((cf) => cf.filterKey === filterOption.filterKey && cf.feature === filterOption.feature);
    if (pageWithPG.includes(filter.pageType) && filterOption.filterKey === 0) {
      return {
        ...filterOption,
        options: matchingFilter && matchingFilter.options.length > 1 ? [] : matchingFilter?.options || [],
      };
    }
    return {
      ...filterOption,
      options: matchingFilter ? matchingFilter.options : filterOption.options,
    };
  }

  // Helper to adjust selectedFilters for a single filter
  export function adjustSelectedFilters(
    filter: SelectedFilters,
    currentPageFilters: Filters[] | undefined,
    pageWithPG: PageType[],
  ) {
    return {
      ...filter,
      selectedFilters: filter.selectedFilters.map((filterOption) =>
        getAdjustedFilterOptions(filterOption, filter, currentPageFilters, pageWithPG),
      ),
    };
  }